import { useQueryParam, withDefault } from "use-query-params";

import { DEFAULT_TABLE_STATE } from "@features/sales-v4/constants";
import { type TableState } from "@features/sales-v4/types";
import { CustomJsonCompressedParam } from "@north-beam/nb-common";

const TableStatesParam = CustomJsonCompressedParam<TableState[]>();

export const useTableStatesQueryParams = () => {
  const [tableStates, setTableStates] = useQueryParam(
    "tableStates",
    withDefault<TableState[], TableState[]>(TableStatesParam, [
      DEFAULT_TABLE_STATE,
    ]),
    { updateType: "pushIn" },
  );

  return {
    tableStates,
    setTableStates,
  };
};
